import React, { useState, useEffect } from "react";
import { loadFromStorage, saveToStorage } from "./utils/cartStorage";
import TopNav from "./TopNav";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CartComponent from "./CartComponent";

export default function OrderConfirmation({ cart, customAlert, permanentAlert, popupState, setPopupState }) {
    const buyerInfo = loadFromStorage("buyerInfo", {});
    const useTrackAndTrace = loadFromStorage("useTrackTrace", false);
    const [agreeToTerms, setAgreedToTerms] = useState(false);
    const paymentMethod = loadFromStorage("paymentMethod");
    const [loading, setLoading] = useState(true);
    const [shippingCostInfo, setShippingCostInfo] = useState(null);
    const [termsAndConditions, setTermsAndConditions] = useState(null);
    const [products, setProducts] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchAll = async () => {
            try {
                const [shippingRes, productsRes, termsRes] = await Promise.all([
                    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/shippingcostInfo`),
                    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/products`),
                    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/content/terms-and-conditions`)
                ]);

                setShippingCostInfo(shippingRes.data);
                setProducts(productsRes.data);
                setTermsAndConditions(termsRes.data);
            } catch (err) {
                console.error("Error loading data", err);
            } finally {
                setLoading(false);
            }
        };

        fetchAll();
    }, []);

    
    // console.log(`cart: ${JSON.stringify(cart)}`);
    // console.log(`buyerinfo: ${JSON.stringify(buyerInfo)}`);
    if (!buyerInfo || buyerInfo == {} || !buyerInfo.name || !cart || cart.length == 0) {
        return (
            <>
                <TopNav cart={cart} />
                <div className="pane dark_pane">
                    <div className="left">
                        <h2>Nothing here...</h2>
                        <p>Your cart is empty</p>
                    </div>
                </div>
            </>
        );
    }


    const addressHtml = (buyerInfo.addressLines || []).filter(Boolean).join("<br>");

    if (loading) return <p>Loading...</p>;

    if (!shippingCostInfo) {
        return <div>Loading shipping info...</div>;
    }

    const totalExcludingShipping = cart.reduce((sum, item) => {
        const product = products.find(p => p._id === item.productId);
        return sum + product.price * item.quantity;
    }, 0);

    const VAT_RATE = parseFloat(process.env.REACT_APP_VAT_RATE || "0")
    let total = totalExcludingShipping;
    let shippingCosts = 0;

    if (totalExcludingShipping < shippingCostInfo.threshold) {
        total += shippingCostInfo.costs;
        shippingCosts = shippingCostInfo.costs;
    }

    let trackTraceCosts = 0;

    if (useTrackAndTrace && parseFloat(process.env.REACT_APP_TRACK_TRACE_COSTS) > 0) {
        trackTraceCosts = parseFloat(process.env.REACT_APP_TRACK_TRACE_COSTS);
        total += trackTraceCosts;
    }

    const placeOrder = async () => {
        if (!agreeToTerms) {
            customAlert("Please confirm that you agree to the terms and conditions");
            return;
        }

        if (!buyerInfo || buyerInfo == {} || !buyerInfo.name || !cart || cart == {}) {
            customAlert("Your cart is empty");
        }

        console.log(`Fetching CSRF token from ${process.env.REACT_APP_BACKEND_URL}...`);

        const csrfResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/csrf-token`, {
            credentials: "include" // crucial for cookies
        });
        const csrfData = await csrfResponse.json();

        console.log("Token: " + csrfData.csrfToken);
        const csrfToken = csrfData.csrfToken;

        console.log("Placing order");
        const jsonBody = JSON.stringify({ /*orderNumber: ,*/items: cart, buyerInfo, paymentMethod: paymentMethod.code, useTrackAndTrace });
        console.log(jsonBody);

        permanentAlert("Payment is being prepared. Please wait...");

        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/order`, {
            method: "POST",
            headers: { "Content-Type": "application/json", "CSRF-Token": csrfToken },
            credentials: "include",
            body: jsonBody
        });

        if (!response.ok) {
            const errorData = await response.json();
            customAlert(`Order failed: ${errorData.error || 'Unknown error'}`);
            return;
        }

        const data = await response.json();

        console.log("Order result: " + JSON.stringify(data));
        console.log("payment URL: " + data.paymentUrl);

        if (data.paymentUrl && data.orderNumber) {
            localStorage.removeItem("cart");
            localStorage.removeItem("buyerInfo");
            saveToStorage("lastOrderId", data.orderNumber); // or Id?
            window.location.href = data.paymentUrl;
        }

    };

    console.log(`Selected payment method: ${paymentMethod.displayName}`);




    return (
        <div>
            <script type="text/javascript" language="JavaScript">console.log("loading page...")</script>
            <TopNav cart={cart} />
            <div className="pane dark_pane">
                <div className="left_right_container">
                    <h1>Order confirmation</h1>
                    <p>
                        Please, verify your personal information, the order details, selected payment methods, and <a href="#"
                            role="button"
                            onClick={(e) => {
                                e.preventDefault();
                                setPopupState({ type: 'termsAndConditions' })
                                // your click logic here
                            }}>terms &amp; conditions</a> below.
                    </p>
                    <div className="left">
                        <h2>Order Details</h2>
                        <CartComponent
                            cart={cart}
                            products={products}
                            shippingCostInfo={shippingCostInfo}
                            editable={false}
                        />
                    </div>
                    <div className="right">
                        <h2>Personal information</h2>
                        <p>
                            {buyerInfo.name}<br />
                            {addressHtml}<br />
                            {buyerInfo.zipCode} {buyerInfo.city}<br />
                            {buyerInfo.country}
                        </p>
                        <h2>Payment Method</h2>
                        <div key={`payment-container-${paymentMethod.code}`} className="form-group">
                            <div>
                                <label>Selected payment method:</label>
                                <span><strong>{paymentMethod.displayName}</strong></span>
                                {/* <img alt={paymentMethod.code} src={`media/${paymentMethod.code}.png`} /> */}
                            </div>
                        </div>
                        <h2>Terms &amp; conditions</h2>
                        <p>
                            <input
                                type="checkbox"
                                required
                                checked={agreeToTerms}
                                onChange={(e) => setAgreedToTerms(e.target.checked)}
                            />
                            I hereby agree to the <a href="#"
                                role="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setPopupState({ type: 'termsAndConditions' })
                                    // your click logic here
                                }}>terms &amp; conditions</a>.</p>
                    </div>
                </div><br />
                <hr />
                <div className="form-group">
                    <button
                        className="add"
                        onClick={() => navigate('/payment')}>Back</button>
                    <button type="button" className="add" onClick={placeOrder}>Place Order</button>
                </div>
            </div>

            {(popupState?.type === "termsAndConditions") && (
                <div className="product-popup-scrolling">
                    <div className="pane">
                        <h2>Terms and Conditions</h2>
                        <p dangerouslySetInnerHTML={{ __html: termsAndConditions.content }} />
                        <div className="popup-buttons">
                            <button onClick={() => setPopupState(null)}>Ok</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
